import { EventEmitter, OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
var NotesComponent = /** @class */ (function () {
    function NotesComponent(cdr, el) {
        this.cdr = cdr;
        this.el = el;
        this.notesChange = new EventEmitter();
    }
    Object.defineProperty(NotesComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            this._value = val;
        },
        enumerable: true,
        configurable: true
    });
    NotesComponent.prototype.ngOnInit = function () {
        this.isExpanded = this.value && this.isHubActivityFormEnabled;
    };
    NotesComponent.prototype.onNotesChange = function ($event) {
        if (!this.value && !$event) {
            return;
        }
        // Simply emit the raw content without any sanitization
        // Sanitization will happen only on save
        this.notesChange.emit($event);
    };
    NotesComponent.prototype.onFocus = function () {
        if (this.isHubActivityFormEnabled) {
            this.isExpanded = true;
            this.cdr.detectChanges();
        }
        this.bubbleClickEvent();
    };
    // notes editor textarea is placed inside an iframe
    // that's why clicks on it aren't captured by dropdowns and suggesters clickOutside handlers
    NotesComponent.prototype.bubbleClickEvent = function () {
        var eventName = 'mouseup';
        var event;
        if (typeof (Event) === 'function') {
            event = new Event(eventName, { bubbles: true, cancelable: true });
        }
        else {
            // to support IE
            event = document.createEvent('Event');
            event.initEvent(eventName, true, true);
        }
        this.el.nativeElement.dispatchEvent(event);
    };
    return NotesComponent;
}());
export { NotesComponent };
